import { __extends } from "tslib";
import Resource from './resource';
import User from '../models/user';
import { Visit } from '../models';
var UsersModule = (function (_super) {
    __extends(UsersModule, _super);
    function UsersModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsersModule.prototype.signUp = function (data) {
        var _this = this;
        return this.client.http.post('/auth/register', data).then(function (_a) {
            var _b = _a.data.data, user = _b.user, token = _b.token;
            return _this.setClientAuthentication(user, token);
        });
    };
    UsersModule.prototype.registerEcommUser = function (data) {
        var _this = this;
        return this.client.http.post('/auth/ecommerce/register', data).then(function (_a) {
            var _b = _a.data.data, user = _b.user, token = _b.token, visit = _b.visit;
            return { user: _this.setClientAuthentication(user, token), visit: new Visit(visit, _this.client) };
        });
    };
    UsersModule.prototype.signIn = function (data) {
        var _this = this;
        return this.client.http.post('/auth/login', data).then(function (_a) {
            var _b = _a.data.data, user = _b.user, token = _b.token;
            return _this.setClientAuthentication(user, token);
        });
    };
    UsersModule.prototype.fetch = function () {
        var _this = this;
        return this.client.http.get('/users/me').then(function (_a) {
            var user = _a.data.data;
            return _this.setClientAuthentication(user, _this.client.accessToken);
        });
    };
    UsersModule.prototype.sendForgotPasswordEmail = function (email) {
        return this.client.http.post('/auth/forgot-password', { email: email }, { hideSuccessAlert: true });
    };
    UsersModule.prototype.resetPassword = function (email, token, password) {
        return this.client.http.post('/auth/reset-password', { email: email, token: token, password: password });
    };
    UsersModule.prototype.fetchTreatmentPlans = function () {
        return this.client.http
            .get('/users/me/treatment-plans')
            .then(function (_a) {
            var treatmentPlans = _a.data.data;
            return treatmentPlans;
        });
    };
    UsersModule.prototype.fetchTreatmentPlan = function (code) {
        return this.client.http
            .get("/treatment-plans/" + code)
            .then(function (_a) {
            var treatmentPlans = _a.data.data;
            return treatmentPlans;
        });
    };
    UsersModule.prototype.getCurrentUser = function () {
        return this.client.currentUser;
    };
    UsersModule.prototype.setClientAuthentication = function (profile, token) {
        var user = new User(profile, this.client);
        this.client.setCurrentUser(user);
        this.client.setAccessToken(token);
        return user;
    };
    return UsersModule;
}(Resource));
export default UsersModule;
//# sourceMappingURL=users.js.map